module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Chat5-cfb1f06311b6df0113bc619051cee163.svg";